import type { Messages } from "@prop/i18n";
import type en from "../en/security";

export default {
  title: "Безопасность",
  lead: "Кто и как входит в ваш аккаунт: второй фактор, коды восстановления, устройства и пароль.",
  mfa: {
    title: "Двухэтапная проверка",
    on: "Включена",
    off: "Выключена",
    requiredStaff: "Обязательна для сотрудников: админка закрыта, пока вы не добавите второй фактор.",
    recommended: "Рекомендуем: защищает аккаунт и выплаты, даже если пароль утёк.",
    addTotp: "Добавить приложение-аутентификатор",
    addKey: "Добавить ключ безопасности или passkey",
    keyLabel: "Название ключа",
    keyLabelDefault: "Ключ безопасности",
    remove: "Удалить",
    lastUsed: "Последний раз {when}",
    never: "ещё не использовался",
    totpScan: "Отсканируйте код в Google Authenticator, 1Password, Authy или похожем приложении либо введите ключ вручную.",
    totpSecret: "Ключ",
    totpConfirm: "Введите 6-значный код из приложения",
    factorTotp: "Приложение-аутентификатор",
    factorWebauthn: "Ключ безопасности",
  },
  recovery: {
    title: "Резервные коды",
    left: { one: "{count} неиспользованный код", few: "{count} неиспользованных кода", many: "{count} неиспользованных кодов", other: "{count} неиспользованного кода" },
    regenerate: "Создать новые коды",
    show: "Сохраните коды в надёжном месте. Каждый работает один раз; показываем их только сейчас.",
    copy: "Скопировать",
    copied: "Скопировано",
    done: "Я сохранил(а)",
  },
  stepUp: {
    title: "Подтвердите, что это вы",
    hint: "Для чувствительных изменений нужно свежее подтверждение (действует 5 минут).",
    confirm: "Подтвердить",
    cancel: "Отмена",
    activeUntil: "Подтверждено до {time}",
    telegramHint: "Подтвердите в Telegram: нажмите кнопку и подтвердите в нашем боте.",
  },
  sessions: {
    title: "Устройства, где выполнен вход",
    current: "Это устройство",
    revoke: "Выйти",
    revokeAll: "Выйти везде",
    revokeAllConfirm: "Выйти на всех устройствах, и на этом тоже?",
    since: "С {when}",
    seen: "Активность {when}",
    unknownDevice: "Неизвестный браузер",
    showAll: "Показать все ({n})",
    showLess: "Свернуть",
  },
  password: {
    title: "Пароль",
    current: "Текущий пароль",
    new: "Новый пароль",
    change: "Сменить пароль",
    changed: "Пароль изменён. На других устройствах выполнен выход.",
  },
  profile: {
    title: "Профиль",
    save: "Сохранить",
    saved: "Сохранено",
    telegram: "Telegram",
    telegramLinked: "Привязан",
  },
} satisfies Messages<typeof en>;
